import cn from 'classnames';
import { FC } from 'react';

import { type TimelinePreview } from './Timeline.types';
import styles from './TimelinePreviewImage.module.scss';

type TimelinePreviewImageProps = TimelinePreview & {
  className?: string;
};

export const TimelinePreviewImage: FC<TimelinePreviewImageProps> = (props) => {
  const { src, alt, contain, light, testID, className, onError } = props;

  return (
    <div className={cn(styles.container, light && styles.light, className)}>
      <img
        className={cn(styles.image, contain && styles.contained)}
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        data-testid={testID}
        onError={onError}
      />
    </div>
  );
};
